import React from 'react';
import PropTypes from 'prop-types';
import QuestionIcon from './QuestionIcon';

export default function CommissionTotalsItem(props) {
  const { title, description, value, valueClassName, hint } = props;

  return (
    <div className="commissions-totals-item">
      <div className="commissions-totals-item-title">
        <span>{title}</span>
        <QuestionIcon tooltip={{ title, content: description }} />
      </div>
      <div className={`commissions-totals-item-value ${valueClassName}`}>
        {value}
      </div>
      <div className="commissions-totals-item-hint">
        {hint && hint?.length > 0 ? hint : ''}
      </div>
    </div>
  );
}

CommissionTotalsItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  valueClassName: PropTypes.string,
  hint: PropTypes.string,
};

CommissionTotalsItem.defaultProps = {
  valueClassName: '',
  hint: '',
};
